module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "i": "root"
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "pt0",
    attrs: {
      "id": "root_header"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "root-bottom line-t",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "menues clearfix"
  }, [_c('div', {
    staticClass: "menue",
    class: {
      'active': _vm.footer.ac0
    },
    on: {
      "click": function($event) {
        return _vm.toUrl('/')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont bg1"
  }), _vm._v(" "), _c('div', {
    staticClass: "menue-txt"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "menue",
    class: {
      'active': _vm.footer.ac1
    },
    on: {
      "click": function($event) {
        return _vm.toUrl('/root_classify')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont bg2"
  }), _vm._v(" "), _c('div', {
    staticClass: "menue-txt"
  }, [_vm._v("分类")])]), _vm._v(" "), _c('div', {
    staticClass: "menue",
    class: {
      'active': _vm.footer.ac2
    },
    on: {
      "click": function($event) {
        return _vm.islogin('/root_cart')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont bg3"
  }), _vm._v(" "), _c('div', {
    staticClass: "menue-txt"
  }, [_vm._v("购物车")])]), _vm._v(" "), _c('div', {
    staticClass: "menue",
    class: {
      'active': _vm.footer.ac3
    },
    on: {
      "click": function($event) {
        return _vm.toUrl('/root_personal')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont bg4"
  }), _vm._v(" "), _c('div', {
    staticClass: "menue-txt"
  }, [_vm._v("我的")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1f23b3da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Root.vue
// module id = 1428
// module chunks = 131